// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"12d39b9a9f2f2934","5763":"062154ec54598301","6893":"2971834c1551006e","6974":"f587815c02192709","7222":"d89815026b878d1c","7937":"0f0f6faa1a4236cb"}[chunkId] + ".js";
};